<HomeNavBar />
<InactivityModal />

<main class="profile-directory-page profile-directory-page-business">


  <section class="profile-directory-toolbar">
    <div class="profile-directory-search">
      <i class="bi bi-search" aria-hidden="true"></i>
      <input
        type="text"
        class="form-control"
        placeholder="Search businesses"
        v-model="businessSearch"
      >
      <button
        v-if="businessSearch"
        type="button"
        class="profile-directory-clear d-inline-flex align-items-center justify-content-center"
        @click="clear_search"
        aria-label="Clear search"
      >
        <i class="bi bi-x-lg" aria-hidden="true"></i>
      </button>
    </div>
  </section>

  <section v-if="loading" class="profile-directory-state">
    <Loader :loading="loading" />
  </section>

  <section v-else-if="filteredBusinesses.length" class="profile-directory-grid">
    <article
      v-for="business in filteredBusinesses"
      :key="business.id"
      class="profile-directory-card"
    >
      <div class="profile-directory-card-top">
        <span class="profile-directory-avatar profile-directory-avatar-fallback d-inline-flex align-items-center justify-content-center" aria-hidden="true">
          <i class="bi bi-briefcase-fill"></i>
        </span>

        <span class="profile-directory-status d-inline-flex align-items-center gap-1">
          <i class="bi bi-building-check" aria-hidden="true"></i>
          Business
        </span>
      </div>

      <div class="profile-directory-card-body">
        <h5 class="profile-directory-name">{{ get_business_name(business) }}</h5>

        <div class="d-inline-flex align-items-center gap-2 bg-soft-warning p-1 px-3 rounded border border-warning border-opacity-10 mt-2">
          <span class="text-warning fw-bold small">
            <i class="bi bi-star-fill me-1"></i>{{ business.rating || '0.0' }}
          </span>
          <span class="vr bg-warning opacity-50"></span>
          <span class="text-dark fw-bold text-xxs">
            {{ business.totalRatings || 0 }} {{ (business.totalRatings === 1) ? 'Review' : 'Reviews' }}
          </span>
        </div>
      </div>

      <button
        type="button"
        class="btn profile-directory-action"
        @click="view_profile(business)"
      >
        <span>Visit Profile</span>
        <i class="bi bi-arrow-right" aria-hidden="true"></i>
      </button>
    </article>
  </section>

  <section v-else class="d-flex flex-column align-items-center justify-content text-center profile-directory-empty">
    
    <span class="profile-directory-empty-icon d-inline-flex align-items-center justify-content-center">
      <img :src="home_feature_icons.business_profile" alt="Business profiles" class="profile-directory-empty-icon-image">
    </span>
    <h5>No businesses found</h5>
    <p>
      No matching business profiles are available.
    </p>
  </section>
</main>

<StickyNav />
